import { Stack, Typography } from '@mui/material';
import { IEquipmentPrevOrder, IPrescription } from 'API';
import { shorterDateFormat, slashDateFormat } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { format } from 'date-fns';

interface ITitle {
  requestNumber?: string;
  order: IPrescription;
}

export const Title = ({ requestNumber, order }: ITitle) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const isDesktop = useIsDesktop();

  return (
    <Stack>
      <Stack gap={isDesktop ? '16px' : '8px'}>
        <Typography variant={'h2'} color={'text.secondary'}>
          {`${dictionary.prescription}: ${
            order.code || dictionary.commingSoon
          }`}
        </Typography>
      </Stack>

      {order.createDate && (
        <Stack mt={2} mb={2}>
          <Typography>
            {dictionary.startDate}{' '}
            {format(new Date(order.createDate), shorterDateFormat)}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
